export default __webpack_public_path__ + "static/screenshot_6-9803d63136b9c638b929861061e365ae.png";